import React, { useMemo } from 'react';
import { Line } from '@react-three/drei';
import * as THREE from 'three';

function BackgroundGrid() {
  const gridLines = useMemo(() => {
    const lines = [];
    const size = 100;
    const divisions = 20;
    const step = size / divisions;
    const halfSize = size / 2;
    
    // Horizontal lines
    for (let i = 0; i <= divisions; i++) {
      const y = -halfSize + i * step;
      lines.push({
        points: [
          new THREE.Vector3(-halfSize, 0, y),
          new THREE.Vector3(halfSize, 0, y)
        ]
      });
    }
    
    // Vertical lines
    for (let i = 0; i <= divisions; i++) {
      const x = -halfSize + i * step;
      lines.push({
        points: [
          new THREE.Vector3(x, 0, -halfSize),
          new THREE.Vector3(x, 0, halfSize)
        ]
      });
    }
    
    return lines;
  }, []);
  
  // NO ANIMATION - COMPLETELY STATIC
  return (
    <group position={[0, -0.1, 0]}>
      {gridLines.map((line, i) => (
        <Line
          key={i}
          points={line.points}
          color="#05f3ff"
          lineWidth={0.3}
          transparent
          opacity={0.08}
        />
      ))}
    </group>
  );
}

export default BackgroundGrid;